<template>
    <div ref="three_bar"></div>
</template>

<script>
import ThreeBar from "!!raw-loader!../../assets/ricoh_assets/icons/ICN002-08_three_bar.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.three_bar.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = ThreeBar

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>